import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-center" }
const _hoisted_2 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_3 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_4 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_5 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_6 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_7 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_8 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_9 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_10 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_11 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_12 = { class: "pl-0 pr-1 py-0 ma-0" }
const _hoisted_13 = { class: "pl-0 pr-1 py-0 ma-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, { "no-gutters": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "d-flex" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tabs, {
              modelValue: _ctx.year,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.year) = $event))
            }, {
              default: _withCtx(() => [
                (_ctx.charge.isLineReported)
                  ? (_openBlock(), _createBlock(_component_v_tab, {
                      key: 0,
                      value: "0",
                      href: "#0",
                      style: {"justify-content":"left"}
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode(" Exercice N-1 ")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_tab, {
                  value: "1",
                  href: "#1",
                  style: {"justify-content":"left"}
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode(" Exercice N ")
                  ])),
                  _: 1
                }),
                (_ctx.parameters.periodsNumber > 1)
                  ? (_openBlock(), _createBlock(_component_v_tab, {
                      key: 1,
                      value: "2",
                      href: "#2",
                      style: {"justify-content":"left"}
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode(" Exercice N+1 ")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.parameters.periodsNumber > 2)
                  ? (_openBlock(), _createBlock(_component_v_tab, {
                      key: 2,
                      value: "3",
                      href: "#3",
                      style: {"justify-content":"left"}
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode(" Exercice N+2 ")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.parameters.periodsNumber > 3)
                  ? (_openBlock(), _createBlock(_component_v_tab, {
                      key: 3,
                      value: "4",
                      href: "#4",
                      style: {"justify-content":"left"}
                    }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode(" Exercice N+3 ")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.parameters.periodsNumber > 4)
                  ? (_openBlock(), _createBlock(_component_v_tab, {
                      key: 4,
                      value: "5",
                      href: "#5",
                      style: {"justify-content":"left"}
                    }, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createTextVNode(" Exercice N+4 ")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_v_icon, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.displayReinitializationDialog = true))
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("$refresh")
                ])),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_tabs_window, {
      modelValue: _ctx.year,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.year) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.charge.isLineReported)
          ? (_openBlock(), _createBlock(_component_v_window_item, {
              key: 0,
              value: "0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_data_table, {
                  items: _ctx.charge.detailsNM1[0],
                  headers: _ctx.detailsHeaders,
                  itemsPerPage: _ctx.charge.detailsNM1[0].length,
                  "hide-default-footer": "",
                  class: "table"
                }, {
                  item: _withCtx((props) => [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_2, _toDisplayString(props.item.title), 1),
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], (month) => {
                        return _createElementVNode("td", {
                          key: props.item.months[month].date,
                          class: "pl-0 pr-1 py-0 ma-0"
                        }, [
                          _createVNode(_component_oss_text_field_filled, {
                            "hide-details": "",
                            disabled: "",
                            "model-value": props.item.months[month].amount
                          }, null, 8, ["model-value"])
                        ])
                      }), 64)),
                      _createElementVNode("td", _hoisted_3, [
                        _createVNode(_component_oss_text_field_filled, {
                          "hide-details": "",
                          disabled: "",
                          modelValue: props.item.total,
                          "onUpdate:modelValue": ($event: any) => ((props.item.total) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["items", "headers", "itemsPerPage"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_window_item, { value: "1" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_data_table, {
              items: _ctx.detailsItems[0],
              headers: _ctx.detailsHeaders,
              itemsPerPage: _ctx.detailsItems[0].length,
              "hide-default-footer": "",
              class: "table"
            }, {
              item: _withCtx((props) => [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_4, _toDisplayString(props.item.title), 1),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], (month) => {
                    return _createElementVNode("td", {
                      key: props.item.months[month].date,
                      class: "pl-0 pr-1 py-0 ma-0"
                    }, [
                      _createVNode(_component_oss_text_field_filled, {
                        modelValue: props.item.months[month].amount,
                        "onUpdate:modelValue": ($event: any) => ((props.item.months[month].amount) = $event),
                        "hide-details": "auto",
                        min: 0,
                        disabled: 
                                        !props.item.editable ||
                                        (props.item.uneditedCount <= 1 &&
                                            !props.item.months[month].edited)
                                    ,
                        onChange: ($event: any) => (_ctx.recomputeWhenChange([], props.index, month)),
                        "data-cy": 'test'
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
                    ])
                  }), 64)),
                  _createElementVNode("td", _hoisted_5, [
                    _createVNode(_component_oss_text_field_filled, {
                      "hide-details": "",
                      disabled: props.index === 1,
                      modelValue: props.item.total,
                      "onUpdate:modelValue": ($event: any) => ((props.item.total) = $event)
                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["items", "headers", "itemsPerPage"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "2" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_data_table, {
              items: _ctx.detailsItems[1],
              headers: _ctx.detailsHeaders,
              itemsPerPage: _ctx.detailsItems[1].length,
              "hide-default-footer": "",
              class: "table"
            }, {
              item: _withCtx((props) => [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_6, _toDisplayString(props.item.title), 1),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], (month) => {
                    return _createElementVNode("td", {
                      key: props.item.months[month].date,
                      class: "pl-0 pr-1 py-0 ma-0"
                    }, [
                      _createVNode(_component_oss_text_field_filled, {
                        "hide-details": "",
                        disabled: 
                                        !props.item.editable ||
                                        (props.item.uneditedCount <= 1 &&
                                            !props.item.months[month].edited)
                                    ,
                        onChange: ($event: any) => (_ctx.recomputeWhenChange([], props.index, month)),
                        modelValue: props.item.months[month].amount,
                        "onUpdate:modelValue": ($event: any) => ((props.item.months[month].amount) = $event)
                      }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                    ])
                  }), 64)),
                  _createElementVNode("td", _hoisted_7, [
                    _createVNode(_component_oss_text_field_filled, {
                      "hide-details": "",
                      disabled: props.index === 1,
                      modelValue: props.item.total,
                      "onUpdate:modelValue": ($event: any) => ((props.item.total) = $event)
                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["items", "headers", "itemsPerPage"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "3" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_data_table, {
              items: _ctx.detailsItems[2],
              headers: _ctx.detailsHeaders,
              itemsPerPage: _ctx.detailsItems[2].length,
              "hide-default-footer": "",
              class: "table"
            }, {
              item: _withCtx((props) => [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_8, _toDisplayString(props.item.title), 1),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], (month) => {
                    return _createElementVNode("td", {
                      key: props.item.months[month].date,
                      class: "pl-0 pr-1 py-0 ma-0"
                    }, [
                      _createVNode(_component_oss_text_field_filled, {
                        "hide-details": "",
                        disabled: 
                                        !props.item.editable ||
                                        (props.item.uneditedCount <= 1 &&
                                            !props.item.months[month].edited)
                                    ,
                        onChange: ($event: any) => (_ctx.recomputeWhenChange([], props.index, month)),
                        modelValue: props.item.months[month].amount,
                        "onUpdate:modelValue": ($event: any) => ((props.item.months[month].amount) = $event)
                      }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                    ])
                  }), 64)),
                  _createElementVNode("td", _hoisted_9, [
                    _createVNode(_component_oss_text_field_filled, {
                      "hide-details": "",
                      disabled: props.index === 1,
                      modelValue: props.item.total,
                      "onUpdate:modelValue": ($event: any) => ((props.item.total) = $event)
                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["items", "headers", "itemsPerPage"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_data_table, {
              items: _ctx.detailsItems[3],
              headers: _ctx.detailsHeaders,
              itemsPerPage: _ctx.detailsItems[3].length,
              "hide-default-footer": "",
              class: "table"
            }, {
              item: _withCtx((props) => [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_10, _toDisplayString(props.item.title), 1),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], (month) => {
                    return _createElementVNode("td", {
                      key: props.item.months[month].date,
                      class: "pl-0 pr-1 py-0 ma-0"
                    }, [
                      _createVNode(_component_oss_text_field_filled, {
                        "hide-details": "",
                        disabled: 
                                        !props.item.editable ||
                                        (props.item.uneditedCount <= 1 &&
                                            !props.item.months[month].edited)
                                    ,
                        onChange: ($event: any) => (_ctx.recomputeWhenChange([], props.index, month)),
                        modelValue: props.item.months[month].amount,
                        "onUpdate:modelValue": ($event: any) => ((props.item.months[month].amount) = $event)
                      }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                    ])
                  }), 64)),
                  _createElementVNode("td", _hoisted_11, [
                    _createVNode(_component_oss_text_field_filled, {
                      "hide-details": "",
                      disabled: props.index === 1,
                      modelValue: props.item.total,
                      "onUpdate:modelValue": ($event: any) => ((props.item.total) = $event)
                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["items", "headers", "itemsPerPage"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "5" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_data_table, {
              items: _ctx.detailsItems[4],
              headers: _ctx.detailsHeaders,
              itemsPerPage: _ctx.detailsItems[4].length,
              "hide-default-footer": "",
              class: "table"
            }, {
              item: _withCtx((props) => [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_12, _toDisplayString(props.item.title), 1),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], (month) => {
                    return _createElementVNode("td", {
                      key: props.item.months[month].date,
                      class: "pl-0 pr-1 py-0 ma-0"
                    }, [
                      _createVNode(_component_oss_text_field_filled, {
                        "hide-details": "",
                        disabled: 
                                        !props.item.editable ||
                                        (props.item.uneditedCount <= 1 &&
                                            !props.item.months[month].edited)
                                    ,
                        onChange: ($event: any) => (_ctx.recomputeWhenChange([], props.index, month)),
                        modelValue: props.item.months[month].amount,
                        "onUpdate:modelValue": ($event: any) => ((props.item.months[month].amount) = $event)
                      }, null, 8, ["disabled", "onChange", "modelValue", "onUpdate:modelValue"])
                    ])
                  }), 64)),
                  _createElementVNode("td", _hoisted_13, [
                    _createVNode(_component_oss_text_field_filled, {
                      "hide-details": "",
                      disabled: props.index === 1,
                      modelValue: props.item.total,
                      "onUpdate:modelValue": ($event: any) => ((props.item.total) = $event)
                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["items", "headers", "itemsPerPage"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
    _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_oss_dialog, {
      modelValue: _ctx.displayReinitializationDialog,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.displayReinitializationDialog) = $event)),
      height: "25%",
      title: "Réinitialisation des détails",
      width: "45vw"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, { class: "py-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, {
                  subheader: "",
                  lines: "two"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item, {
                      class: "oss-list-item mb-2 rounded-lg",
                      onClick: _ctx.reinitializeYear
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_v_btn_next)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => _cache[11] || (_cache[11] = [
                            _createTextVNode("Réinitialiser uniquement l'exercice sélectionné")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_list_item, {
                      class: "oss-list-item mb-2 rounded-lg",
                      onClick: _ctx.reinitializeAll
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_v_btn_next)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => _cache[12] || (_cache[12] = [
                            _createTextVNode("Réinitialiser tous les exercices")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}